import { ReferenceMeasurementState } from '@/api/generator';
import { NotificationMessage } from '@/components/notifications/types';
import { t } from 'i18next';

export function getReferenceMeasurementNotification(
  referenceMeasurementState?: ReferenceMeasurementState,
): NotificationMessage | undefined {
  const notifications: Record<ReferenceMeasurementState, NotificationMessage | undefined> = {
    [ReferenceMeasurementState.Outdated]: {
      message: t('ReferenceMeasurementOutdated'),
      type: 'warning',
      closable: false,
    },
    [ReferenceMeasurementState.CalibrationMissing]: {
      message: t('CalibrationMissing'),
      type: 'warning',
      closable: false,
    },
    [ReferenceMeasurementState.Undefined]: {
      message: t('ReferenceMeasurementMissing'),
      type: 'warning',
      closable: false,
    },
    [ReferenceMeasurementState.Valid]: undefined,
  };

  return notifications[referenceMeasurementState ?? ReferenceMeasurementState.Undefined];
}
